<template>
    <div class="grid">
        <loading :active="isLoadingModel" :can-cancel="true" color="#274461" :is-full-page="fullPage"></loading>
        <div class="col-12">
            <div class="card">
                <Breadcrumb :home="breadcrumbHome" :model="breadcrumbItems">
                <!--<template #item="{ item, props }">
                    <router-link v-if="item.to" v-slot="{ href, navigate }" :to="item.to" custom>
                        <a :href="href" v-bind="props.action" @click="navigate">
                            <span :class="[item.icon, 'text-color']" />
                            <span class="text-primary font-semibold">{{ item.label }}</span>
                        </a>
                    </router-link>
                </template>-->
                <template #item="{ item, props }">
                     <router-link v-if="item.to" v-slot="{ href, navigate }"  :to="item.to" custom>
                        <a :href="href"   @click="navigate" >
                            <span :class="[item.icon, 'text-color']" ></span>
                            <span class="text-primary font-semibold">{{ item.label }}</span>
                        </a>
                    </router-link> 
                    <a v-else :href="item.url" :target="item.target" v-bind="props.action">
                    <span class="text-color">{{ item.label }}</span>
                </a>
                </template>
            </Breadcrumb>
                <Toast />
                <div class="p-fluid formgrid grid" style="margin-top: 2%">
                    <div class="field col-12 md:col-2">
                        <span class="p-float-label">
                            <InputText type="text" v-model="search_name"></InputText>
                            <label for="name">Category Name</label>
                        </span>
                    </div>
                    <div class="field col-12 md:col-2">
                        <Button style="background-color: #349ce4; border: 1px solid #349ce4" icon="pi pi-search"
                            @click="search(1)" v-tooltip.bottom="'Search'" />
                    </div>
                </div>
                <DataView :value="products" :layout="layout" :rows="rows">
                    <template #empty>
                        <div class="text-center">
                            <b style="text-align: center">No records found.</b>
                        </div>
                    </template>
                    <template #header>
                        <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                            <h5  style="color:#274461"><b>{{ album_name }} Category  </b></h5>
                            <div>
                                <Button icon="pi pi-refresh" @click="search(2)"
                                    style="background-color: #349ce4; border: 1px solid #349ce4"
                                    v-tooltip.bottom="'Refresh'" />
                                <Button icon="pi pi-plus" class="ml-2" style="background-color: #349ce4"
                                    v-tooltip.bottom="'Add'" @click="openNew" />
                            </div>
                        </div>
                        <div style="text-align: right; font-weight: bold">
                            <!-- <span>Total Category :</span>{{ totalRecords }} -->
                        </div>
                    </template>
                    <template #grid="slotProps">
                        <div class="grid grid-nogutter" v-if="slotProps.items">
                            <div class="col-12 md:col-3" v-for="(item, index) in slotProps.items" :key="index">
                                <div class="card m-3 border-1 surface-border" style="background-color: #F6F6F6; box-shadow:rgba(0, 0, 0, 0.5) 0px 8px 12px 0px !important;">
                                    <div style="height: 30px;">
                                        <span v-if="item.status=='Active' ||item.status=='active'"><badge :value=item.status severity="success"></badge></span>
                            <span v-else-if="item.status=='InActive' ||item.status=='In Active'"><badge :value=item.status severity="warning"></badge></span>
                            <span v-else-if="item.status=='Delete' ||item.status=='Deleted'"><badge :value=item.status severity="danger"></badge></span>
                            
                                    </div>
                                    <div class="text-center">
                                        <img v-if="item.image" :src="item.image" alt="" style="height: 35%; width: 35%;">
                                        <img v-else src="images/notfound.png" alt="" style="height: 75%; width: 70%;">
                                        
                                    </div>
                                    <div class="text-center" style="height: 70px;">
                                            <p class="text-2xl font-bold" style="color:#274461">
                                                <b>{{ capitalizeFirstLetter(item.category_name)}}</b>
                                            </p>
                                    </div>
                                    <div class="flex align-items-center justify-content-center">
                                        <!-- <button style="background-color: #349ce4;border: 1px solid #349ce4;" class="p-button p-button-sm flex-auto ml-2" type="button" @click="editProduct(item)">
                                            <span class="p-button-icon p-button-icon-left pi pi-pencil"></span>
                                            <span class="p-button-label" data-pc-section="label" style="margin-left: -20%">Edit</span>
                                        </button>
                                        <button style="background-color: #F65501;border: 1px solid #F65501;" class="p-button p-button-sm flex-auto ml-2" type="button" @click="confirmDeleteProduct(item)">
                                            <span class="p-button-icon p-button-icon-left pi pi-trash"></span>
                                            <span class="p-button-label" data-pc-section="label" style="margin-left: -20%">Delete</span>
                                        </button> -->
                                        <Button
                                            icon="pi pi-pencil"
                                            title="Edit Client"
                                            v-tooltip.bottom="'Edit'"
                                            class="p-button-rounded p-button-warning mr-2"
                                            @click="editProduct(item)"
                                            />&nbsp;&nbsp;
                                            <Button
                                                icon="pi pi-trash"
                                                v-tooltip.bottom="'Delete'"
                                                class="p-button-rounded p-button-danger mr-2"
                                                @click="confirmDeleteProduct(item)"
                                            />
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    </template>
                </DataView>
                <div class="pageno">
                    <Paginator :rows="rows" :totalRecords="totalRecords" :rowsPerPageOptions="[6, 9, 24, totalRecords]"
                        @page="onPageChange"></Paginator>
                </div>
                <Dialog v-model:visible="productDialog" @hide="reset" :style="{ width: '600px' }" header="Category Form"
                    :modal="true">
                    <div class="col-12">
                        <div class="card">
                            <div class="p-fluid formgrid grid">
                                <div class="field col-12 md:col-12">
                                    <label for="name">Category Name</label>
                                    <InputText id="name" type="text" v-model.trim="product.category_name"
                                        required="true" />
                                </div>
                                <div class="field col-12 md:col-12">
                                    <label for="name">Category Url</label>
                                    <InputText id="name" type="text" v-model.trim="product.category_url"
                                        required="true" />
                                </div>
                                <div class="field col-12 md:col-6" style="margin-top: 1%">
               
                                    <Button
                                    style="background-color: #349CE4; border: 1px solid #349CE4;"
                                    label="Upload Image"
                                    @click="toggleShow"
                                    icon="pi pi-check"
                                    class="p-button"
                                    />
                                    <my-upload
                                    field="img"
                                    @crop-success="cropSuccess"
                                    langType="en"
                                    v-model="show_image"
                                    :width="width"
                                    :height="height"
                                    :url="url"
                                    :params="params"
                                    :headers="headers"
                                    img-format="png"
                                    :noCircle="true"
                                    :noRotate="false"
                                    >
                                    </my-upload>
                                </div>
                                <div class="field col-12 md:col-6">
                                    <Image v-if="imgDataUrl" :src="imgDataUrl" alt="Image" width="100" preview />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 md:col-6">
                        <Button style="
                background-color: white;
                border: 1px solid #349ce4;
                color: #349ce4;
              " v-if="product_old.category_name" label="UPDATE" icon="pi pi-check" class="p-button mr-1 mb-1" @click="adduser" />
                        <Button v-else style="
                background-color: white;
                border: 1px solid #349ce4;
                color: #349ce4;
              " label="ADD" icon="pi pi-check" class="p-button mr-1 mb-1" @click="adduser" />&nbsp;&nbsp;&nbsp;
                        <Button style="background-color: #349ce4" label="Cancel" icon="pi pi-times"
                            class="p-button mr-1 mb-1" @click="reset" />
                    </div>
                </Dialog>
                <Dialog v-model:visible="deleteProductDialog" :style="{ width: '450px' }" header="Confirm"
                    :modal="true">
                    <div class="flex align-items-center justify-content-center">
                        <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
                        <span v-if="product">Are you sure you want to delete <b>{{ product.category_name }}</b>?</span>
                    </div>
                    <template #footer>
                        <Button label="No" icon="pi pi-times" class="p-button-text"
                            @click="deleteProductDialog = false" />&nbsp;&nbsp;&nbsp;
                        <Button label="Yes" icon="pi pi-check" class="p-button-text" @click="deletegroup" />
                    </template>
                </Dialog>
            </div>
        </div>
    </div>
</template>
<script>
import { FilterMatchMode } from "primevue/api";
import ProductService from "../service/ProductService";
import BreadcrumbService from "../service/BreadcrumbService";
import JsonExcel from "vue-json-excel";
import myUpload from "vue-image-crop-upload";
import {
    GoogleMap,
    Marker,
    MarkerCluster,
    InfoWindow,
    GMapMarker,
    Polyline,
} from "vue3-google-map";
import apis from "@/apis";
import axios from "axios";
import ProgressSpinner from "primevue/progressspinner";
export default {
    data() {
        return {
            album_name:"",
            show_image: false,
            width: 250,
            height: 300,
            url: "",
            params: {
                token: "123456798",
                name: "avatar",
            },
            headers: {
                smail: "*_~",
            },
            imgDataUrl: "",
            Image_data: {
                filePath: "",
                contentType: "",
            },


            rows: 6,
            rowsPerPage: 6,
            perPageOptions: [6, 12, 18, 1000],
            layout: "grid",
            sortKey: null,
            sortOrder: null,
            sortField: null,
            sortOptions: [
                { label: "Price High to Low", value: "!price" },
                { label: "Price Low to High", value: "price" },
            ],
            status_dropdown: [
                { name: "Active", value: "Active" },
                { name: "InActive", value: "InActive" },
                { name: "Deleted", value: "Deleted" },
            ],
            type_dropdown: [
                { name: "Image", value: "image" },
                { name: "Video", value: "video" },
            ],
            type_selected: "",
            search_status: "",
            vehicle_search: "",
            search_name: "",
            selectedvehicle: { name: "", id: "" },
            selecteduser: { name: "", id: "" },
            attachments: "",
            previewImage: null,
            item: {},
            client_id_search: "",
            user_key: "",
            start: "",
            end: "",
            searchme: "",
            name: "",
            page_no: 1,
            isLoading: false,
            isLoadingModel: false,
            loading: false,
            fullPage: true,
            file_attachment: "",
            pick_search: "",
            end_pick_search: "",
            user_type_search: "",
            selectgroupstatus: { name: "", value: "" },
            selectedstatus: { name: "", value: "" },
            products: null,
            productDialog: false,
            deleteProductDialog: false,
            deleteProductsDialog: false,
            lazyParams: {},
            product: {},
            product_old: {},
            selectedProducts: null,
            filters: {},
            offset: 1,
            limit: 6,
            columns: [],
            pageno: 1,
            submitted: false,
            totalRecords: 0,
            id: "",
            BreadcrumbService: null,
            breadcrumbHome: {},
            breadcrumbItems: [],
            album_id:"",
        };
    },
    productService: null,
    async created() {
        this.initFilters();
        this.album_id = this.$route.params.id;
        this.user_key = localStorage.getItem("user_key");
        this.BreadcrumbService = new BreadcrumbService();
        let Breadcrum_data = this.BreadcrumbService.Category();
        this.breadcrumbHome = Breadcrum_data.home;
        this.breadcrumbItems = Breadcrum_data.items;
    },
    async mounted() {
        this.id = this.$route.params.id;
        this.album_id = this.$route.params.id;
        this.lazyParams = {
            first: 0,
            rows: this.limit,
            sortField: null,
            sortOrder: null,
            filters: this.filters,
        };
        if (this.totalRecords == 0) {
            await this.get_count();
        }
        await this.get_list();
    },
    watch: {
        async $route() {
            this.products = [];
            this.columns = [];
            this.totalRecords = 0;
            this.id = this.$route.params.id;
            if (this.id) {
                await this.get_count();
                this.get_list();
            }
        },
    },
    methods: {
        toggleShow() {
      this.show_image = !this.show_image;
    },
    async cropSuccess(imgDataUrl) {console.log(imgDataUrl);
      this.imgDataUrl = imgDataUrl;
      var substrings = imgDataUrl.split(";");
      var contentType = substrings[0].split(":");
      var type = imgDataUrl.split(";")[0].split("/")[1];
      this.handleFileUpload_thumb_with_cropper(
        imgDataUrl,
        type,
        contentType[0]
      );
    },
    async generateString() {
  // Get the current date and time
  const currentDateTime = new Date();

  // Format the date as YYYY_MM_DD
  const formattedDate = currentDateTime.toISOString().split('T')[0].replace(/-/g, '_');

  // Format the time as HH_mm_ss
  const formattedTime = currentDateTime.toTimeString().split(' ')[0].replace(/:/g, '_');

  // Construct the final string
  const resultString = `${formattedDate}_${formattedTime}`;

  return resultString;
},
    async handleFileUpload_thumb_with_cropper(imgDataUrl, type, contentType) {
      

      var prfeix= await this.generateString();
      var filename = this.album_id+"_Category_"+prfeix + "." + type;

      //var filename = this.product.title + "." + type;
      var subimgDataUrl = imgDataUrl.split(",");
      var file = await this.handleFileChange(
        subimgDataUrl[1],
        contentType,
        filename
      );
      this.Image_data = {
        filePath: "",
        contentType: "",
      };
      this.Image_data = {
        filePath:
          "Entertainment/" +
          "Category" +
          "/" +
          filename,
        contentType: contentType,
      };
      this.isLoadingModel = true;
      var promise = apis.upload_to_AWS(this.Image_data);
      promise.then((response) => {
        axios
          .put(response.data.data, file, {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-Type": contentType,
            },
          })
          .then((response) => {
            this.isLoadingModel = false;
            this.$toast.add({
              severity: "success",
              summary: "success",
              detail: "Upload Successfully",
              life: 3000,
            });
            return false;
          });
      });
    },
    async handleFileChange(base64, content_Type, filename) {
      const base64String = base64;
      const contentType = content_Type;
      const byteCharacters = atob(base64String);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: contentType });
      const fileName = filename;
      var file = new File([blob], fileName, { type: contentType });
      return file;
    },
    
        async onPageChange(event) {
            this.currentPage = event.page + 1;
            this.page_no = event.page + 1;
            this.rows = event.rows;
            this.limit = event.data;
            await this.get_list();
            await this.get_count();
        },
        window_up() {
            window.scrollTo({ top: 0, behavior: "smooth" });
        },
        capitalizeFirstLetter(str) {
            if (str && typeof str === "string") {
                return str.charAt(0).toUpperCase() + str.slice(1);
            } else {
                return "";
            }
        },
        isImage(url) {
            return /\.(jpeg|jpg|gif|png)$/i.test(url);
        },
        async date_time_prefix() {
            const currentDateTime = new Date();
            const formattedDate = currentDateTime
                .toISOString()
                .split("T")[0]
                .replace(/-/g, "_");
            const formattedTime = currentDateTime
                .toTimeString()
                .split(" ")[0]
                .replace(/:/g, "_");
            const resultString = `${formattedDate}_${formattedTime}`;
            return resultString;
        },
        isNumber(evt) {
            const charCode = evt.which ? evt.which : evt.keyCode;
            if (
                charCode > 31 &&
                (charCode < 48 || charCode > 57) &&
                charCode !== 46
            ) {
                evt.preventDefault();
            }
        },
        async search(count) {
            if (count == 2) {
                this.search_status = "";
                this.search_name = "";
                this.type_selected = "";
            }
            await this.get_list();
            await this.get_count();
        },
        
        async onPage(event) {
            this.lazyParams = event;
            this.page_no = event.page + 1;
            this.limit = event.rows;
            if (this.totalRecords > 0) {
                this.get_list();
            }
        },
        get_count: function () {
            var data = {
                count: true,
                category_name: this.search_name,
                "album_id"  :this.album_id
            };
            this.isLoadingModel = true;
            var promise = apis.AlbumList_byID(data, this.id);
            promise.then((response) => {
                this.isLoadingModel = false;
                console.log(response);
                this.totalRecords = response.data.data;
            });
            console.log(data);
        },
        get_list: function () {
            var data = {
                limit: this.limit,
                page_no: this.page_no,
                count: false,
                category_name: this.search_name,
                "album_id"  :this.album_id
            };
            console.log(data);
            this.isLoadingModel = true;
            var promise = apis.AlbumList_byID(data, this.id);
            promise.then((response) => {
                this.isLoadingModel = false;
                console.log(response);
                this.products = response.data.data[0].category_list;
                this.album_name =  response.data.data[0].album_name;
                console.log(this.products[0]);
                if (this.columns.length == 0) {
                    if (this.products.length > 0) {
                        this.columns = Object.keys(this.products[0]);
                    }
                }
            });
            console.log(data);
        },
        openNew() {
            this.product = {};
            this.product_old = {};
            this.submitted = false;
            this.productDialog = true;
            this.imgDataUrl="";
            this.Image_data = {
                filePath: "",
                contentType: "",
            };
        },
        hideDialog() {
            this.productDialog = false;
            this.submitted = false;
        },
        async adduser() {
            this.submitted = true;
            if (!this.product.category_name) {
                this.$toast.add({
                    severity: "error",
                    summary: "error",
                    detail: "Please Enter Category name",
                    life: 3000,
                });
                return false;
            }
            //edit
            if (this.product_old.category_name) {
                var image = this.product.image;
                if (this.Image_data.filePath != "") {
                    image =encodeURI("https://media.geoc.in/" +this.Image_data.filePath);
                }
                
                if (!image || image=='' || image==undefined || image==null) 
                {
                    this.$toast.add({
                    severity: "error",
                    summary: "error",
                    detail: "Please Upload Image",
                    life: 3000,
                    });
                    return false;
                }
                var data = {
                   // _id: this.product._id,
                    "album_id": this.album_id,
                    "category_name": this.product_old.category_name,
                    "category_url": this.product.category_url,
                    "new_name":this.product.category_name,
                    "image":image
                };
                this.isLoadingModel = true;
                var promise = apis.UpdateCategory(data);
                promise
                    .then((responseapi) => {
                        this.$swal(responseapi.data.message);
                        this.isLoadingModel = false;
                        this.productDialog = false;
                        this.get_list();
                        this.get_count();
                    })
                    .catch((error) => {
                        //console.log(error);
                        this.isLoadingModel = false;
                        this.productDialog = false;
                        this.$swal.fire(error.response.data);
                        this.get_list();
                        this.get_count();
                    });
            }
            //add-----------------------------------------------------------------------------------------------------------------
            else {
                var image = encodeURI("https://media.geoc.in/" +this.Image_data.filePath);

                if (!this.Image_data.filePath || this.Image_data.filePath=='' || this.Image_data.filePath==undefined || this.Image_data.filePath==null) 
                {
                    this.$toast.add({
                    severity: "error",
                    summary: "error",
                    detail: "Please Upload Image",
                    life: 3000,
                    });
                    return false;
                }

                var data1 = {
                    
                    "album_id": this.album_id,
                    "category_name": this.product.category_name,
                    "category_url": this.product.category_url,
                    "image":image
                };
             
               
                this.isLoadingModel = true;
                var promises = apis.addCategory(data1);
                promises
                    .then((response) => {
                        this.isLoadingModel = false;
                        this.productDialog = false;
                        this.$swal(response.data.message);
                        this.get_list();
                        this.get_count();
                    })
                    .catch((error) => {
                        //console.log(error);
                        this.isLoadingModel = false;
                        this.productDialog = false;
                        this.$swal.fire(error.response.data);
                        this.get_list();
                        this.get_count();
                    });
            }
        },
        reset() {
            this.product = {};
            this.product_old = {};
            this.selectedstatus = { name: "", value: "" };
            this.attachments = "";
            this.previewImage = null;
            this.productDialog = false;
        },
        format_time(data) {
            if (data) {
                const date = new Date(data);
                return date;
            } else {
                return "";
            }
        },
        editProduct(product) {
            this.Image_data = {
                filePath: "",
                contentType: "",
            };
            this.product = { ...product };
            this.product_old = { ...product };
            this.productDialog = true;
            if (this.product["image"] != "") {
                this.imgDataUrl = this.product["image"];
            }
        },
        
        confirmDeleteProduct(product) {
            this.product = product;
            this.deleteProductDialog = true;
        },
        deleteProduct() {
            this.products = this.products.filter((val) => val.id !== this.product.id);
            this.deleteProductDialog = false;
            this.product = {};
            this.$toast.add({
                severity: "success",
                summary: "Successful",
                detail: "Product Deleted",
                life: 3000,
            });
        },
        deletegroup() {
            if (this.album_id && this.product.category_name) {
                var data = {
                    album_id: this.album_id,
                    "category_name": this.product.category_name
                };
                this.isLoadingModel = true;
                var promise = apis.CategoryDelete(data);
                promise.then((responseapi) => {
                    this.isLoadingModel = false;
                    if (responseapi.data.status == true) {
                        this.deleteProductDialog = false;
                        this.$swal(responseapi.data.message);
                        this.get_list();
                        this.get_count();
                    } else {
                        this.$swal("error to Delete Record");
                    }
                });
            }
        },
        createId() {
            let id = "";
            var chars =
                "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
            for (var i = 0; i < 5; i++) {
                id += chars.charAt(Math.floor(Math.random() * chars.length));
            }
            return id;
        },
        async exportCSV() {
            this.limit = this.totalRecords;
            this.get_list();
            await this.$refs.dt.exportCSV();
        },
        confirmDeleteSelected() {
            this.deleteProductsDialog = true;
        },
        initFilters() {
            this.filters = {
                global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            };
        },
    },
    components: {
        downloadExcel: JsonExcel,
        GoogleMap,
        Marker,
        MarkerCluster,
        InfoWindow,
        GMapMarker,
        Polyline,
        ProgressSpinner,
        "my-upload": myUpload
    },
};
</script>
<style scoped lang="scss">
@import "../assets/demo/badges.scss";

.image-wrapper {
    height: 150px;
}

.circle {
    width: 100px;
    height: 100px;
    line-height: 500px;
    border-radius: 50%;
    font-size: 50px;
    color: #fff;
    text-align: center;
    background: #0cd4e2
}

</style>
